const MARKET_DATE_FORMATTER = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'America/New_York',
});
const hourBucketDates = new Map<number, string>();

/** YYYY-MM-DD in the US equity-market timezone for an epoch-millisecond timestamp. */
export const marketSessionDate = (timestamp: number): string => {
  const bucket = Math.floor(timestamp / 3_600_000);
  const cached = hourBucketDates.get(bucket);
  if (cached) return cached;
  const formatted = MARKET_DATE_FORMATTER.format(new Date(timestamp));
  if (hourBucketDates.size > 4_096) hourBucketDates.clear();
  hourBucketDates.set(bucket, formatted);
  return formatted;
};
